import React from 'react'
import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { BadgeAccessRender } from '@app/components/renderers'

import { CustomEllipsis } from '@app/constants/customEllipsis'

import { ColumnRender } from '@app/types/table'

import { columnTitleMap } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ManagingMonitoringsColumn, ManagingMonitoringsDataSource } from '../types'

const getRender = (key: keyof ManagingMonitoringsColumn): ColumnRender<ManagingMonitoringsColumn> | undefined => {
  switch (key) {
    case 'isActive':
      return function LaunchAccessRender (_, { isActive }) {
        return <BadgeAccessRender hasAccess={ isActive } />
      }
  }
}

const getColumnsOptions = (): Array<Column<ManagingMonitoringsColumn>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof ManagingMonitoringsColumn>

  return columnKeys.map(key => {
    const column: Column<ManagingMonitoringsColumn> = {
      customEllipsis: CustomEllipsis,
      key,
      render: getRender(key),
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

export const getColumns = (): Array<Column<ManagingMonitoringsDataSource>> =>
  [
    ...getColumnsFromMap<ManagingMonitoringsColumn>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<ManagingMonitoringsDataSource>>
